import {
  ActionIcon,
  Badge,
  Button,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { getComplianceStatus, getDeptUsers } from "../apis/userApis";
import BusinessUnitName from "../componenets/getBuName";
import {
  getDepartmentText,
  getComplianceBadgeColor,
  infoColor,
  getDateStatus,
  getStatusColor,
  getStatusText,
  csvDownload,
  excelDownload,
} from "./utilities";
import {
  IconEye,
  IconHistory,
  IconRefresh,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react";
import DoughnutChart from "../componenets/DoughnutChart";
import DoughnutChart3 from "../componenets/DoughnutChart3";
import DoughnutChart2 from "../componenets/DoughnutChart2";
import DoughnutChart4 from "../componenets/DoughnutChart4";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { IconInfoCircle } from "@tabler/icons-react";
import DoughnutChart5 from "../componenets/DoughnutChart5";
import { getCookiesSession } from "../apis/cookiesSession";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";

const DashboardCompliance = () => {
  const userData = JSON.parse(getCookiesSession("userData") || "{}");
  const [uiConfig, setUiConfig] = useState({
    obligations: null,
    loading: true,
  });
  const [countConfig, setCountConifg] = useState({
    page: 1,
    count: 0,
    pageSize: 10,
  });
  const [filtersForData, setFiltersForData] = useState({
    compliant: null,
    department:
      userData.loginAs === "Ob-CXO" || userData.loginAs === "Ob-DeptAdmin"
        ? userData.activeDepartment
        : null,
    businessUnit: userData.loginAs === "Ob-COO" ? userData.businessUnit : null,
    extraCol1: null,
    mapRegion: null,
    assignToId: null,

  });
  const [csvData, setCsvData] = useState([]);
  const [compliantData, setCompliantData] = useState(null);
  const [businessUnitData, setBusinessUnitData] = useState(null);
  const [departmentData, setDepartmentData] = useState(null);
  const [agreementData, setAgreementData] = useState(null);
  const [regionData, setRegionData] = useState(null);
  const [assignedToData, setAssignedToData] = useState(null);
  const [ahModal, setAhModal] = useState(false);
  const [partyNames, setPartyNames] = useState([]);
  const [ahId, setAhId] = useState(0);
  const navigate = useNavigate();
  const [sortByOptions, setSortByOptions] = useState({
    key: "duedate",
    value: "asc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const filterdata = Object.fromEntries(
          Object.entries(filtersForData).filter(([key, value]) => value !== null)
        );
        const response = await getComplianceStatus({
          sortOptions: sortByOptions,
          filters: filterdata,
          page: countConfig.page,
          pageSize: countConfig.pageSize,
        });
        console.log(response);
        setUiConfig({
          loading: false,
          obligations: response.obligations,
        });
        setCountConifg({
          ...countConfig,
          count: response.count,
        });
        setCompliantData(response.compliantStatusCount);
        setBusinessUnitData(response.businessUnitCount);
        setDepartmentData(response.departmentCount);
        setAgreementData(response.agreementCount);
        setRegionData(response.regionCount);
        setCsvData(response.exportData);
        setAssignedToData(response.assignToCount);
        setPartyNames(response.parties);
      } catch (error) {
        console.log("error fetching compliance status: ", error);
      }
    };
    getData();
  }, [countConfig.page, filtersForData, countConfig.pageSize, sortByOptions]);
  let sr = (countConfig.page - 1) * countConfig.pageSize + 1;
  const onViewClick = (id) => {
    window.open(`/viewobligation/${id}`, "_blank");
  };

  const onExport = async () => {
    if (csvData.length > 0) {
      const columnHeaders = Object.keys(csvData[0]);
      excelDownload({
        data: csvData,
        headers: columnHeaders,
        name: "dashboard_obligations",
      });
    }
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID
  const [assignToData, setAssignToData] = useState([
    { label: "assigned to", value: null },
  ]);
  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };
  useEffect(() => {
    const getassignToUsers = async () => {
      try {
        const response = await getDeptUsers();
        setAssignToData(response.userData);
      } catch (error) {
        console.log("error fetching dept users: ", error);
      }
    };
    getassignToUsers();
  }, []);

  //   const headers = [
  //   {
  //     label: "no.",
  //     align: "center",
  //     render: (row, index) => (
  //       <Text size="sm" weight={500} color="dimmed">
  //         {(countConfig.page - 1) * countConfig.pageSize + (index + 1)}
  //       </Text>
  //     ),
  //   },
  //   {
  //     label: "title",
  //     render: (row) => (
  //       <Text size="sm" weight={600} className="text-slate-700" >
  //         {row.title}
  //       </Text>
  //     ),
  //   },
  //   {
  //     label: "obligation",
  //     render: (row) => (
  //       <div
  //         style={{ cursor: "pointer", maxWidth: "250px" }}
  //         onClick={() => handleExpand(row.id)}
  //       >
  //         <Text
  //           size="sm"
  //           color="dark.3"
  //           lineClamp={expandedId === row.id ? undefined : 2}
  //         >
  //           {row.desc}
  //         </Text>
  //       </div>
  //     ),
  //   },
  //   { label: "contract category", key: "extraCol1", align: "center" },
  //   { label: "BU", key: "businessUnit", align: "center" },
  //   { label: "second party", key: "connectedParty", align: "center" },
  //   {
  //     label: "department",
  //     render: (row) => <Text size="sm">{row.dept?.name || "--"}</Text>,
  //   },
  //   {
  //     label: "compliance",
  //     align: "center",
  //     render: (row) => (
  //       <Badge
  //         variant="light"
  //         radius="xl"
  //         size="sm"
  //         color={getComplianceBadgeColor(row.compliant)}
  //       >
  //         {row.compliant}
  //       </Badge>
  //     ),
  //   },
  //   {
  //     label: "timeline",
  //     align: "center",
  //     render: (row) => {
  //       const status = getDateStatus(
  //         row.createdAt,
  //         row.duedate,
  //         row.reminderTime,
  //       );
  //       return (
  //         <Badge
  //           variant="light"
  //           radius="xl"
  //           size="sm"
  //           color={getStatusColor(status)}
  //         >
  //           {getStatusText(status)}
  //         </Badge>
  //       );
  //     },
  //   },
  //   {
  //     label: "actions",
  //     align: "center",
  //     render: (row) => (
  //       <div className="flex flex-row justify-center gap-1">
  //         <ActionIcon
  //           onClick={() => onViewClick(row.id)}
  //           variant="subtle"
  //           // color="#1b6f8d"
  //           radius="md"
  //           color="#1b6f8d"
  //         >
  //           <IconEye size={18} stroke={1.5} color="#1b6f8d"/>
  //         </ActionIcon>
  //         <ActionIcon
  //           onClick={() => {
  //             setAhId(row.id);
  //             setAhModal(true);
  //           }}
  //           variant="subtle"
  //           color="gray"
  //           radius="md"
  //         >
  //           <IconHistory size={18} stroke={1.5} />
  //         </ActionIcon>
  //         {row.extraCol3 !== "" && (
  //           <ActionIcon variant="subtle" radius="md">
  //             <IconInfoCircle
  //               color={infoColor(row.extraCol3)}
  //               size={18}
  //               stroke={1.5}
  //             />
  //           </ActionIcon>
  //         )}
  //       </div>
  //     ),
  //   },
  // ];
  
// const headers = [
//   {
//     label: "SR. NO.",
//     align: "center",
//     render: (row, index) => (
//       <Text size="sm" color="dimmed">
//         {(countConfig.page - 1) * countConfig.pageSize + (index + 1)}
//       </Text>
//     ),
//   },
//   {
//     label: "TITLE",
//     render: (row) => (
//       <Text size="sm" weight={600} className="text-slate-700">
//         {row.title}
//       </Text>
//     ),
//   },
//   {
//     label: "OBLIGATION",
//     render: (row) => (
//       <div
//         style={{ cursor: "pointer", maxWidth: "250px" }}
//         onClick={() => handleExpand(row.id)}
//       >
//         <Text
//           size="sm"
//           color="dark.3"
//           lineClamp={expandedId === row.id ? undefined : 2}
//         >
//           {row.desc}
//         </Text>
//       </div>
//     ),
//   },
//   {
//     label: (
//       <Select
//         placeholder="JOB ORDER"
//         variant="unstyled"
//         withinPortal
//         dropdownPosition="bottom"
//         data={[]}
//         creatable
//         searchable
//         clearable
//         styles={{
//           input: { fontSize: '12px', fontWeight: 600, textTransform: 'none' },
//           rightSection: { pointerEvents: 'none' }
//         }}
//         onCreate={(query) => {
//           setFiltersForData({
//             ...filtersForData,
//             joOrder: { contains: query },
//           });
//         }}
//         getCreateLabel={(query) => `Search "${query}"`}
//       />
//     ),
//     align: "center",
//     render: (row) => <Text size="sm">{row.joOrder || "--"}</Text>,
//   },
//   {
//     label: (
//       <Select
//         placeholder="SECOND PARTY"
//         variant="unstyled"
//         withinPortal
//         dropdownPosition="bottom"
//         searchable
//         clearable
//         data={partyNames}
//         styles={{
//           input: { fontSize: '12px', fontWeight: 600, textTransform: 'none' },
//           rightSection: { pointerEvents: 'none' }
//         }}
//         onChange={(val) => {
//           setFiltersForData({
//             ...filtersForData,
//             OR: val ? [{ brandName: val }, { connectedParty: val }] : null,
//           });
//         }}
//       />
//     ),
//     render: (row) => (
//       <div>
//         <Text size="sm">{row.brandName}</Text>
//         <Text size="xs" color="dimmed">
//           {"(" + row.connectedParty + ")"}
//         </Text>
//       </div>
//     ),
//   },
//   {
//     label: "DEPARTMENT",
//     render: (row) => <Text size="sm">{getDepartmentText(row.department)}</Text>,
//   },
//   {
//     label: (
//       <Select
//         placeholder="ASSIGNED TO"
//         variant="unstyled"
//         withinPortal
//         dropdownPosition="bottom"
//         clearable
//         data={assignToData}
//         styles={{
//           input: { fontSize: '12px', fontWeight: 600, textTransform: 'none' },
//           rightSection: { pointerEvents: 'none' }
//         }}
//         onChange={(val) =>
//           setFiltersForData({ ...filtersForData, assignToId: val })
//         }
//       />
//     ),
//     render: (row) => <Text size="sm">{row?.assignTo?.name || "--"}</Text>,
//   },
//   {
//     label: "COMPLIANCE",
//     align: "center",
//     render: (row) => (
//       <Badge
//         variant="light"
//         radius="xl"
//         size="sm"
//         color={getComplianceBadgeColor(row.compliant)}
//       >
//         {row.compliant}
//       </Badge>
//     ),
//   },
//   {
//     label: (
//       <Select
//         placeholder="STATUS"
//         variant="unstyled"
//         withinPortal
//         dropdownPosition="bottom"
//         clearable
//         data={[
//           { label: "upcoming", value: "0" },
//           { label: "due", value: "1" },
//           { label: "overdue", value: "2" },
//         ]}
//         styles={{
//           input: { fontSize: '12px', fontWeight: 600, textTransform: 'none' },
//           rightSection: { pointerEvents: 'none' }
//         }}
//         onChange={(val) => {
//           const now = new Date();
//           if (val === "0") {
//             setFiltersForData({ ...filtersForData, reminderDate: { gt: now }, duedate: null });
//           } else if (val === "1") {
//             setFiltersForData({
//               ...filtersForData,
//               duedate: { gt: now },
//               reminderDate: { lt: now },
//             });
//           } else if (val === "2") {
//             setFiltersForData({ ...filtersForData, duedate: { lt: now }, reminderDate: null });
//           } else {
//             setFiltersForData({ ...filtersForData, duedate: null, reminderDate: null });
//           }
//         }}
//       />
//     ),
//     align: "center",
//     render: (row) => {
//       const status = getDateStatus(row.createdAt, row.duedate, row.reminderTime);
//       return (
//         <Badge
//           variant="light"
//           radius="xl"
//           size="sm"
//           color={getStatusColor(status)}
//         >
//           {getStatusText(status)}
//         </Badge>
//       );
//     },
//   },
//   {
//     label: "ACTIONS",
//     align: "center",
//     render: (row) => (
//       <div className="flex flex-row justify-center gap-1">
//         <ActionIcon onClick={() => onViewClick(row.id)} variant="subtle" color="#1b6f8d">
//           <IconEye size={18} stroke={1.5} />
//         </ActionIcon>
//         <ActionIcon onClick={() => { setAhId(row.id); setAhModal(true); }} variant="subtle" color="gray">
//           <IconHistory size={18} stroke={1.5} />
//         </ActionIcon>
//         {row.extraCol3 && (
//           <ActionIcon variant="subtle">
//             <IconInfoCircle color={infoColor(row.extraCol3)} size={18} stroke={1.5} />
//           </ActionIcon>
//         )}
//       </div>
//     ),
//   },
// ];
const headers = [
  {
    label: "SR. NO.",
    width: "80px",
    align: "center",
    render: (row, index) => (
      <Text size="sm" color="dimmed">
        {(countConfig.page - 1) * countConfig.pageSize + (index + 1)}
      </Text>
    ),
  },
  {
    label: "TITLE",
    width: "200px",
    render: (row) => (
      <Text size="sm" weight={600} className="text-slate-700">
        {row.title}
      </Text>
    ),
  },
  {
    label: "OBLIGATION",
    width: "250px",
    render: (row) => (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => handleExpand(row.id)}
      >
        <Text
          size="sm"
          color="dark.3"
          lineClamp={expandedId === row.id ? undefined : 2}
        >
          {row.desc}
        </Text>
      </div>
    ),
  },
  {
    label: (
      <Select
        placeholder="JOB ORDER"
        variant="unstyled"
        withinPortal
        dropdownPosition="bottom"
        data={[]}
        creatable
        searchable
        clearable
        styles={{
          root: { width: '100%', minWidth: '150px' },
          input: { fontSize: '12px', fontWeight: 600, textTransform: 'none', color: '#64748b' },
          rightSection: { pointerEvents: 'none' }
        }}
        onCreate={(query) => {
          setFiltersForData({
            ...filtersForData,
            joOrder: { contains: query },
          });
        }}
        getCreateLabel={(query) => `Search "${query}"`}
      />
    ),
    width: "180px",
    align: "center",
    render: (row) => <Text size="sm" weight={500}>{row.joOrder || "--"}</Text>,
  },
  {
    label: (
      <Select
        placeholder="SECOND PARTY"
        variant="unstyled"
        withinPortal
        dropdownPosition="bottom"
        searchable
        clearable
        data={partyNames}
        styles={{
          root: { width: '100%', minWidth: '180px' },
          input: { fontSize: '12px', fontWeight: 600, textTransform: 'none', color: '#64748b' },
          rightSection: { pointerEvents: 'none' }
        }}
        onChange={(val) => {
          setFiltersForData({
            ...filtersForData,
            OR: val ? [{ brandName: val }, { connectedParty: val }] : null,
          });
        }}
      />
    ),
    width: "520px",
    render: (row) => (
      <div>
        <Text size="sm" weight={500}>{row.brandName}</Text>
        <Text size="xs" color="dimmed">
          {"(" + row.connectedParty + ")"}
        </Text>
      </div>
    ),
  },
  {
    label: "DEPARTMENT",
    width: "150px",
    render: (row) => <Text size="sm" weight={500}>{getDepartmentText(row.department)}</Text>,
  },
  {
    label: (
      <Select
        placeholder="ASSIGNED TO"
        variant="unstyled"
        withinPortal
        dropdownPosition="bottom"
        clearable
        data={assignToData}
        styles={{
          root: { width: '100%', minWidth: '150px' },
          input: { fontSize: '12px', fontWeight: 600, textTransform: 'none', color: '#64748b' },
          rightSection: { pointerEvents: 'none' }
        }}
        onChange={(val) =>
          setFiltersForData({ ...filtersForData, assignToId: val })
        }
      />
    ),
    width: "180px",
    render: (row) => <Text size="sm" weight={500}>{row?.assignTo?.name || "--"}</Text>,
  },
  {
    label: "COMPLIANCE",
    width: "140px",
    align: "center",
    render: (row) => (
      <Badge
        variant="light"
        radius="xl"
        size="sm"
        color={getComplianceBadgeColor(row.compliant)}
      >
        {row.compliant}
      </Badge>
    ),
  },
  {
    label: (
      <Select
        placeholder="STATUS"
        variant="unstyled"
        withinPortal
        dropdownPosition="bottom"
        clearable
        data={[
          { label: "upcoming", value: "0" },
          { label: "due", value: "1" },
          { label: "overdue", value: "2" },
        ]}
        styles={{
          root: { width: '100%', minWidth: '120px' },
          input: { fontSize: '12px', fontWeight: 600, textTransform: 'none', color: '#64748b' },
          rightSection: { pointerEvents: 'none' }
        }}
        onChange={(val) => {
          const now = new Date();
          if (val === "0") {
            setFiltersForData({ ...filtersForData, reminderDate: { gt: now }, duedate: null });
          } else if (val === "1") {
            setFiltersForData({
              ...filtersForData,
              duedate: { gt: now },
              reminderDate: { lt: now },
            });
          } else if (val === "2") {
            setFiltersForData({ ...filtersForData, duedate: { lt: now }, reminderDate: null });
          } else {
            setFiltersForData({ ...filtersForData, duedate: null, reminderDate: null });
          }
        }}
      />
    ),
    width: "150px",
    align: "center",
    render: (row) => {
      const status = getDateStatus(row.createdAt, row.duedate, row.reminderTime);
      return (
        <Badge
          variant="light"
          radius="xl"
          size="sm"
          color={getStatusColor(status)}
        >
          {getStatusText(status)}
        </Badge>
      );
    },
  },
  {
    label: "ACTIONS",
    width: "120px",
    align: "center",
    render: (row) => (
      <div className="flex flex-row justify-center gap-1">
        <ActionIcon onClick={() => onViewClick(row.id)} variant="subtle" color="#1b6f8d">
          <IconEye size={18} stroke={1.5} />
        </ActionIcon>
        <ActionIcon onClick={() => { setAhId(row.id); setAhModal(true); }} variant="subtle" color="gray">
          <IconHistory size={18} stroke={1.5} />
        </ActionIcon>
        {row.extraCol3 && (
          <ActionIcon variant="subtle">
            <IconInfoCircle color={infoColor(row.extraCol3)} size={18} stroke={1.5} />
          </ActionIcon>
        )}
      </div>
    ),
  },
];
  return (
    <>
      <div className="m-4">
        <div className="mb-6 flex justify-between">
          {/* <Text className=" text-3xl font-semibold">compliance status</Text> */}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {compliantData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">compliance</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart
                  compliantData={compliantData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={compliantData.map(
                    (item) => `${item.compliant}/${item._count.id}`
                  )}
                  datafor={compliantData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {!filtersForData.businessUnit && businessUnitData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                business unit
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart2
                  businessUnitData={businessUnitData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={businessUnitData.map(
                    (item) => `${item.name}/${item._count.id}`
                  )}
                  datafor={businessUnitData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {filtersForData.businessUnit && regionData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                business regions
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart5
                  businessUnitData={regionData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={regionData.map(
                    (item) => `${item.name}/${item._count.id}`
                  )}
                  datafor={regionData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {departmentData !== null && !filtersForData.department && (
            <div className="chart-container">
              <Text className="font-medium block text-center">department</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart3
                  departmentData={departmentData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={departmentData.map(
                    (item) =>
                      `${getDepartmentText(item.department)}/${item._count.id}`
                  )}
                  datafor={departmentData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {assignedToData !== null && filtersForData.department && (
            <div className="chart-container">
              <Text className="font-medium block text-center">assigned to</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart3
                  departmentData={assignedToData}
                  filtersForData={null}
                  setFiltersForData={setFiltersForData}
                  labels={assignedToData.map(
                    (item) => `${item.assignedTo}/${item._count.id}`
                  )}
                  datafor={assignedToData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {agreementData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                connected contract
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart4
                  agreementData={agreementData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={agreementData.map(
                    (item) => `${item.extraCol1 + ""}/${item._count.id}`
                  )}
                  datafor={agreementData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-end">
        <div className="flex justify-center">
          <div className="flex">
            <Select
              value={sortByOptions.key}
              onChange={(val) => handleKeyChange(val)}
              data={[
                { label: "start date", value: "startDate" },
                { label: "due date", value: "duedate" },
                { label: "second party", value: "connectedParty" },
                { label: "id", value: "id" },
                { label: "brand name", value: "brandName" },
                { label: "title", value: "title" },
              ]}
            />

            <ActionIcon className="mx-2" onClick={toggleOrder}>
              {sortByOptions.value === "asc" ? (
                <IconSortAscending size={32} />
              ) : (
                <IconSortDescending size={32} />
              )}
            </ActionIcon>
          </div>
          <ActionIcon
            className="my-auto"
            onClick={() => window.location.reload()}
          >
            <IconRefresh size={30} />
          </ActionIcon>
          <Button
            className="ml-4 text-center btn p-2"
            style={{ backgroundColor: "#1b6f8d" }}
            onClick={onExport}
          >
            Export
          </Button>
        </div>
      </div>
     
      <>
          <UniversalTable
            headers={headers}
            data={uiConfig.obligations}
            loading={false} // Connect your loading state here
          />

          <TablePagination
            totalCount={countConfig.count}
            page={countConfig.page}
            pageSize={countConfig.pageSize}
            dataLength={uiConfig.obligations?.length || 0}
            onPageChange={(val) =>
              setCountConifg({ ...countConfig, page: val })
            }
            onPageSizeChange={(val) =>
              setCountConifg({ ...countConfig, pageSize: val, page: 1 })
            }
          />
        </>
      <Modal
        opened={ahModal}
        onClose={() => {
          setAhModal(false);
          setAhId(0);
        }}
        title="oblligation action history"
        size="calc(80vw)"
      >
        <ObligationTranHistoryModal id={ahId} />
      </Modal>
    </>
  );
};

export default DashboardCompliance;
